import { authorizedAxios } from 'library/axios/apiProvider';

export async function getFaq() {
  const { data } = await authorizedAxios().get<any>(`/api/v1/faq/`);
  return data;
}
